module.exports={Remove:"Kaldır"};